import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface RequiredListWhenYesRule {
  controlName: string;
  errorKey: string;
  getItems: () => unknown[] | null | undefined;
}

function isYes(value: unknown): boolean {
  return value === true || String(value).toLowerCase() === 'yes' || String(value).toLowerCase() === 'true';
}

export function requiredListWhenYesValidator(
  rules: RequiredListWhenYesRule[]
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const errors: ValidationErrors = {};

    for (const rule of rules) {
       const control = group.get(rule.controlName);
      const controlValue = control?.value;
      const items = rule.getItems() ?? [];
  
       const shouldError = isYes(controlValue) && items.length === 0;

      if (shouldError) {
        errors[rule.errorKey] = true;
        control?.setErrors({ ...(control.errors ?? {}), [rule.errorKey]: true });
      }
    }
    
    return Object.keys(errors).length ? errors : null;
  };
}

//usage example:
// validators: requiredListWhenYesValidator([
//       {
//         controlName: 'anyHealthConditions',
//         errorKey: 'healthConditionRequired',
//         getItems: () => this.model?.applicantDetails?.healthCondition ?? []
//       },